<template>
  <div class="order-reject-product" v-if="rejectProduct">
    <div class="reject-product-title">
      <div class="txt">
        拒签无忧
        <span class="tips-icon" @click="showRejectProductRules"></span>
      </div>
    </div>

    <div class="reject-product-content">
      <table class="s-table reject-product-table">
        <thead>
          <tr>
            <th>产品ID</th>
            <th>产品名称</th>
            <th>产品价格</th>
            <th>赔付比例</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td class="table-name">{{rejectProduct.reject_product_id}}</td>
            <td class="table-name">{{rejectProduct.reject_product_name}}</td>
            <td class="table-name">{{(rejectProduct.sell_price / 100).toFixed(2)}}元/人</td>
            <td class="table-name">{{rejectProduct.ratio}}%</td>
          </tr>
        </tbody>
      </table>

      <div class="reject-product-applicant-list">
        <div class="applicant-list-label">
          <div>保障人</div>
        </div>
        <div class="applicant-list">
          <div class="applicant-info" v-for="item in rejectProduct.applicant_set" :key="item.applicant_id">
            <span class="applicant-info-name">{{ item.applicant_name }}</span>
            <!-- 0保障生效中 1保障成功 2保障结束 3保障已赔付 -->
            <span :class="['applicant-info-status', item.status === 3 ? 'success' : '']">{{ rejectProductStatus[item.status] }}{{ item.status === 3 ? '（赔付金额￥'+ ((item.payout_amount || 0) / 100).toFixed(2) + '）' : '' }}</span>
          </div>
        </div>
      </div>

    </div>

  </div>
</template>

<script>
import status from '../../libs/status';
import NoticeModal from '@/components/common/modals/notice-modal/notice-modal';

export default {
  props: {
    order: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      rejectProductStatus: status.rejectProductStatus,
    };
  },
  computed: {
    rejectProduct() {
      return this.order.reject_product_set || undefined;
    },
  },
  methods: {
    // 显示规则
    showRejectProductRules() {
      NoticeModal.modal({
        title: '拒签无忧',
        message: this.rejectProduct.rule,
        showCancelButton: false,
        showConfirmButton: false,
        isTextareaMessage: true,
        confirmButtonText: '我知道了',
        confirmMethod: () => {
        },
      });
    },
  },
};
</script>

<style lang="less" scoped>
.order-reject-product {
  margin-top: 20px;
  background-color: #fff;
  padding: 16px 24px 20px 24px;
  .reject-product-title {
    display: flex;
    flex: 1;
    align-items: center;
    .txt {
      font-size: 16px;
      font-weight: 600;
      color: #333;
    }
    .tips-icon {
      display: inline-block;
      width: 18px;
      height: 18px;
      margin-left: 8px;
      background: url(../../assets/imgs/ordering/tips.png) no-repeat center / 100% 100%;
      vertical-align: bottom;
      cursor: pointer;
    }
  }
  .reject-product-content {
    .reject-product-table {
      border: 1px solid #E9EEF2;
      border-collapse: collapse;
      thead{
        th{
          background-color: rgba(89,159,255,0.1);
          text-align: center;
          height: 48px;
        }
      }
      tbody{
        tr{
          td{
            text-align: center;
            height: 48px;
          }
        }
      }
    }

    .reject-product-applicant-list {
      margin-top: 16px;
      background: #FAFBFC;
      display: flex;
      .applicant-list-label {
        padding: 16px 0;
        color: #5F666E;
        font-size: 16px;
        >div {
          width: 96px;
          height: 100%;
          display: flex;
          justify-content: center;
          align-items: center;
          border-right: 1px solid #E9EEF2;
        }
      }
      .applicant-list {
        flex: 1;
        .applicant-info {
          display: flex;
          justify-content: space-between;
          align-items: center;
          font-size: 16px;
          padding: 16px 24px;
          border-bottom: 1px dotted #E9EEF2;
          &:last-of-type {
            border-bottom: none;
          }
          .applicant-info-name {
            flex: 1;
            color: #2F333D;
          }
          .applicant-info-status {
            color: #91999F;
            &.success {
              color: #52C41A;
            }
          }
        }
      }
    }

  }
}

</style>



// WEBPACK FOOTER //
// src/components/order-detail/order-reject-product.vue